import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {Error404Component} from './error404/error404.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        Error404Component,
    ]
})
export class HttpErrorModule {
}
